import { useDrag } from './DragContext';

export default function EmptySlotNode({ collectionId, slotPosition, isCompact, isUltraCompact, isMiniCompact, isShared = false, slotId, onClick }) {
  const borderColor = isShared ? 'border-orange-500' : 'border-indigo-500';
  const { isDragging, hoveredSlot, setHovered, handleDrop } = useDrag();

  const isHovered = isDragging && hoveredSlot === slotId;

  const handleMouseEnter = () => {
    if (isDragging) {
      setHovered(slotId);
    }
  };

  const handleMouseLeave = () => {
    if (isDragging && hoveredSlot === slotId) {
      setHovered(null);
    }
  };

  const handleMouseUp = () => {
    if (isDragging && hoveredSlot === slotId) {
      handleDrop(collectionId, slotPosition);
    }
  };

  const handleClick = (e) => {
    // Only trigger click if we're not in the middle of a drag operation
    if (!isDragging && onClick) {
      e.stopPropagation();
      onClick();
    }
  };

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseUp={handleMouseUp}
      onClick={handleClick}
      className={`bg-gray-800 border-2 border-dashed ${borderColor} rounded-xl flex items-center justify-center cursor-pointer select-none ${isDragging ? '' : 'transition-transform duration-200'} ${isMiniCompact ? 'w-24 h-16 p-1.5' : isUltraCompact ? 'w-32 h-20 p-2' : isCompact ? 'w-40 h-24 p-3' : 'w-52 h-32 p-4 sm:p-5'} ${isHovered ? 'scale-110' : 'hover:scale-105'}`}>
      <div className="flex flex-col items-center space-y-1">
        <svg className={`text-gray-500 flex-shrink-0 ${isMiniCompact ? 'w-2.5 h-2.5' : isUltraCompact ? 'w-3 h-3' : isCompact ? 'w-3 h-3 sm:w-4 sm:h-4' : 'w-4 h-4 sm:w-5 sm:h-5'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </svg>
        <p className={`text-gray-400 font-semibold ${isMiniCompact ? 'text-[8px]' : isUltraCompact ? 'text-[10px]' : isCompact ? 'text-xs' : 'text-sm'}`}>Empty Slot</p>
      </div>
    </div>
  );
}
